const trackConsent = ({ consentType, consent }) => {
  const userDataElement = document.getElementById("user-data-tag");
  const userData = userDataElement ? JSON.parse(userDataElement.textContent) : {};

  if (!userData.id) {
    return;
  }

  $.ajax({
    url: "/user_consents",
    type: "POST",
    data: { consent_type: consentType, consent: consent },
    error: (error) => {
      console.error("Failed to track profiling consent:", error);
    }
  });
};

const checkOsanoConsent = () => {
  const consent = window.Osano?.cm?.getConsent();
  const analyticsConsent = consent?.ANALYTICS === "ACCEPT";
  const profilingConsent = consent?.MARKETING === "ACCEPT";
  const functionalityConsent = consent?.PERSONALIZATION === "ACCEPT";

  trackConsent({ consentType: "profiling", consent: profilingConsent });

  window._hsp = window._hsp || [];
  window._hsp.push(["setHubSpotConsent", {
    analytics: analyticsConsent,
    advertisement: profilingConsent,
    functionality: functionalityConsent,
  }]);
};

// Pre-load Osano (ref: https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api#-pre-load-and-windowosano)
(function (w, o, d) {
  w[o] =
    w[o] ||
    function () {
      w[o][d].push(arguments);
    };
  w[o][d] = w[o][d] || [];
})(window, 'Osano', 'data');

window.Osano("onConsentSaved", checkOsanoConsent);

const selectOsanoElementsByConsentModel = () => {
  const consentModel = window.Osano?.cm?.consentModel ?? 'explicit';
  const hiddenConsentModel = consentModel === 'explicit' ? 'implicit' : 'explicit';
  const styleSheet = `.osano-mode-${hiddenConsentModel} { display: none; }`;

  const existingStyleElement = document.getElementById('osano-consent-handling-style');

  if (existingStyleElement) {
    existingStyleElement.textContent = styleSheet;
  } else {
    const styleElement = document.createElement('style');
    styleElement.id = 'osano-consent-handling-style';
    styleElement.textContent = styleSheet;
    document.head.appendChild(styleElement);
  }
};

window.Osano("onInitialized", selectOsanoElementsByConsentModel);
